import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var LoggingUtil = /*#__PURE__*/function () {
  function LoggingUtil() {
    _classCallCheck(this, LoggingUtil);
  }

  _createClass(LoggingUtil, null, [{
    key: "get",
    value: function get(object, path) {
      var defval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      // eslint-disable-next-line no-param-reassign
      if (typeof path === 'string') path = path.split('.');
      return path.reduce(function (xs, x) {
        return xs !== undefined && xs[x] !== undefined ? xs[x] : defval;
      }, object);
    }
  }, {
    key: "canPromise",
    value: function canPromise() {
      return !!window.Promise;
    }
  }]);

  return LoggingUtil;
}();

export { LoggingUtil as default };